module.exports = __webpack_public_path__ + "img/bbu.360b2a15.png";